<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    :viewBox="viewBox"
  >
    <g data-name="グループ 12435">
      <path
        data-name="パス 5018"
        d="M664.414 166.646a2.119 2.119 0 0 0-2.292.048l-8.285 5.893h-5.588a1.281 1.281 0 0 0-1.28 1.279v6.8a1.282 1.282 0 0 0 1.28 1.281h5.085l8.859 6.244a2.156 2.156 0 0 0 2.224 0 2.251 2.251 0 0 0 1.076-1.921v-17.7a2.254 2.254 0 0 0-1.079-1.924zm-1.131 19.63-8.97-6.326a1.093 1.093 0 0 0-.633-.2h-4.518v-4.968h5.024a1.1 1.1 0 0 0 .636-.2l8.468-6.023.008.015z"
        transform="translate(-645.596 -161.53)"
        :style="{ fill: color }"
      />
      <path
        data-name="パス 5019"
        d="m675.137 177.554 2.882-2.881a1.1 1.1 0 1 0-1.552-1.552L673.585 176l-2.881-2.882a1.1 1.1 0 1 0-1.552 1.552l2.881 2.881-2.881 2.881a1.1 1.1 0 0 0 1.552 1.552l2.881-2.882 2.882 2.882a1.1 1.1 0 0 0 1.552-1.552z"
        transform="translate(-647.47 -161.6)"
        :style="{ fill: color }"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'SpeakerOffSVG',
  props: {
    size: {
      type: String,
      default: '32px',
    },
    viewBox: {
      type: String,
      default: '0 0 32 32',
    },
    color: {
      type: String,
      default: '#0075c2',
    },
  },
};
</script>
